<script>
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import getSelectionIcon from 'root/services/selection-icons.service';

  export let hide, cancel;

  const GBTA_MODULES = [
    {id: 'PB', label: 'Property Basic'},
    {id: 'CS', label: 'Client Specific'},
    {id: 'SS', label: 'Safety & Security'},
    {id: 'BD', label: 'Blackout/Fair Dates'},
    {id: 'ES', label: 'Extended Stay'},
    {id: 'GM', label: 'Group/Meetings'},
    {id: 'CSR', label: 'Corporate Social Responsibility'}
  ];

  let selected = GBTA_MODULES;

  function toggleSelected(module){
    if(selected.includes(module)){
      selected = selected.filter(item => item !== module);
    } else {
      selected = [...selected, module];
    }
  }

  function onExport(){
    hide(selected.map(s => s.id));
  }

</script>

<ClosableModal width="480px" close="{cancel}">
  <div slot="heading"
       class="Heading"
  >
    <div>GBTA Modules Selection</div>
    <div class="Text">Select GBTA modules you would like to include in the export:</div>
  </div>

  <div class="Table">
    {#each GBTA_MODULES as module}
      <div class="Module"
           class:Selected={selected.includes(module)}
           data-icon-before="{getSelectionIcon(selected.includes(module))}"
           on:click="{() => toggleSelected(module)}"
      >
        <b>{module.id}</b>&nbsp;-&nbsp;{module.label}
      </div>
    {/each}
  </div>

  <div class="Actions">
    <button class="aBtn asLarge atLight"
            on:click={cancel}>
      Cancel
    </button>

    <button class="aBtn asLarge atLight asMain"
            disabled="{!selected.length}"
            on:click={onExport}
    >
      Export
    </button>
  </div>
</ClosableModal>

<style lang="stylus">

  .Heading {
    font-size: 14px;
    color: #546E7A;
    font-weight: bold;
    padding: 15px;

    .Text {
      font-size: 13px;
      color: #90A4AE;
      font-weight: normal;
    }
  }

  .Table {
    position: relative;
    overflow-y: auto;
    padding: 0 10px;
    margin-top: 5px;

    font-size: 14px;
    text-align: left;
    color: #546e7a;

  }

  .Module {
    display: flex;
    cursor: pointer;
    height: 30px;
    line-height: 30px;

    &:before {
      margin-right: 10px;
    }

    &.Selected:before {
      color: #00A99D;
    }
  }

  .Actions {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px 15px;
  }

</style>
